<template>
  <div>
     <div id="mui-container-fluid">
        <!-- Search Bar Header -->
        <div class="mui-row">
            <div class="mui-panel mui-col-xs-8 mui-col-xs-offset-2 mui-col-md-3 mui-col-md-offset-5 mui--text-center z-3">
                <div class="mui-textfield">
                    <input v-model="minutes" type="number" min="0" v-on:keyup.enter='submit'>
                    <label>Create a timer for how many minutes?</label>
                </div>
                <div v-if="minutes > 0">
                    <router-link v-bind:to="/timer/+minutes" tag="button" class="mui-btn mui-btn--raised mui-btn--primary"><i class="fas fa-play">&nbsp</i>Start this timer</router-link>
                </div>
                <div v-else>
                    <div class="mui--bg-danger" style="height:10px;"></div>
                    Number has to be greater than 0
                    <div class="mui--bg-danger" style="height:10px;"></div>
                </div>
            </div>
        </div>
        <div class="mui-row mui-col-xs-12 buttons"> 
            <router-link to="/timer/1" tag="button" class="mui-btn mui-btn--raised mui-btn--primary"><i class="fas fa-play">&nbsp</i>1 minute</router-link>
            <router-link to="/timer/2" tag="button" class="mui-btn mui-btn--raised mui-btn--primary"><i class="fas fa-play">&nbsp</i>2 minutes</router-link>
            <router-link to="/timer/3" tag="button" class="mui-btn mui-btn--raised mui-btn--primary"><i class="fas fa-play">&nbsp</i>3 minutes</router-link>
            <router-link to="/timer/5" tag="button" class="mui-btn mui-btn--raised mui-btn--primary"><i class="fas fa-play">&nbsp</i>5 minutes</router-link>
        </div>
     </div>


    <!-- <na-timer v-bind:minutesToRun="minutes"></na-timer> -->
  </div>
</template>

<script>
import router from '../routes.js'

export default {
  name: 'home',
  data () {
    return {
      minutes: 10
    }
  },
  methods: {
    submit() {
        router.push({ name: 'timer', params: { minutesToRun: this.minutes }})
    }
  }
}
</script>

<style>
.buttons {
    display: flex;
    flex-wrap: wrap;
    margin: 0px;
    justify-content: center;
    flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue